<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Select a Firearm Storage Location from the list" [matTooltipDisabled]="disabledTooltip(this.firearmStorageLocation)" class="pli-location-field">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.firearmStorageLocation">Firearm Storage Location</mat-label>
          <mat-select formControlName="firearmStorageLocation" id="firearmStorageLocation"
              (ngModelChange)="firearmStorageLocationChanging($event)" [(ngModel)]="item.firearmStorageLocation"
              (ngModelChange)="firearmStorageLocationChanged($event)" #firearmStorageLocation
              placeholder="Firearm Storage Location" [compareWith]="firearmStorageLocationCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearmStorageLocation of firearmStorageLocationSelectionList" [value]="firearmStorageLocation">
              {{firearmStorageLocation.firearmStorageLocationId}} - {{firearmStorageLocation.location}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Valid From Date" [matTooltipDisabled]="disabledTooltip(this.validFromDate)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.validFromDate">Valid From Date</mat-label>
          <input matInput formControlName="validFromDate" id="validFromDate"
              (ngModelChange)="validFromDateChanging($event)" [(ngModel)]="item.validFromDate"
              (ngModelChange)="validFromDateChanged($event)" #validFromDate
              [matDatepicker]="validFromDateDatePicker" placeholder="Valid From Date" required>
          <mat-datepicker-toggle matSuffix [for]="validFromDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #validFromDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Valid To Date" [matTooltipDisabled]="disabledTooltip(this.validToDate)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.validToDate">Valid To Date</mat-label>
          <input matInput formControlName="validToDate" id="validToDate"
              (ngModelChange)="validToDateChanging($event)" [(ngModel)]="item.validToDate"
              (ngModelChange)="validToDateChanged($event)" #validToDate
              [matDatepicker]="validToDateDatePicker" placeholder="Valid To Date" required>
          <mat-datepicker-toggle matSuffix [for]="validToDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #validToDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      <span *ngIf="!createMode">
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="hasDocuments" id="hasDocuments" disabled
              [ngModel]="item.hasDocuments"
              #hasDocuments i18n="@@type.FirearmStorageLocationPLI.hasDocuments">
Has Documents          </mat-slide-toggle>
        </span>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)" class="comments-box">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.comments">Comments</mat-label>
          <textarea matInput formControlName="comments" id="comments" class="field-full-width"
              (ngModelChange)="commentsChanging($event)" [(ngModel)]="item.comments"
              (ngModelChange)="commentsChanged($event)" #comments
              rows="4" maxlength="1000" placeholder="Comments"></textarea>
        </mat-form-field>
      </span>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section" *ngIf="!createMode">

      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy" disabled
              (ngModelChange)="createdByChanging($event)" [ngModel]="item.createdBy"
              (ngModelChange)="createdByChanged($event)" #createdBy
              maxlength="255" placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Date Created" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.createdDate">Date Created</mat-label>
          <input matInput formControlName="createdDate" id="createdDate" disabled
              (ngModelChange)="createdDateChanging($event)" [ngModel]="item.createdDate"
              (ngModelChange)="createdDateChanged($event)" #createdDate
              [matDatepicker]="createdDateDatePicker" placeholder="Date Created">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy" disabled
              (ngModelChange)="updatedByChanging($event)" [ngModel]="item.updatedBy"
              (ngModelChange)="updatedByChanged($event)" #updatedBy
              maxlength="255" placeholder="Updated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Date Updated" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.updatedDate">Date Updated</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate" disabled
              (ngModelChange)="updatedDateChanging($event)" [ngModel]="item.updatedDate"
              (ngModelChange)="updatedDateChanged($event)" #updatedDate
              [matDatepicker]="updatedDateDatePicker" placeholder="Date Updated">
          <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

  </form>
  <section class="crud-item-section">
    <app-firearm-storage-location-pli-document [pliId]="item.firearmStorageLocationPLIId"
      (documentsChanged)="documentsChanged($event)"></app-firearm-storage-location-pli-document>
  </section>
</div>
